import script from "./FinalizedKycModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FinalizedKycModal.vue?vue&type=script&setup=true&lang=ts"

import "./FinalizedKycModal.vue?vue&type=style&index=0&id=6d68d3bc&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d68d3bc"]])

export default __exports__